const JSON2CSV = (nameFile, data) => {
  const str = data
    .map((item) => {
      let line = ''

      Object.keys(item).forEach((key) => {
        line += `${item[key]}|`
      })

      line = line.slice(0, -1)
      return `${line}\r\n`
    })
    .join('')

  const csv = `sep=|\r\n${str}`

  let uri = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`
  uri = uri.replace(/COMMA/g, ',')

  const link = document.createElement('a')
  link.href = uri

  link.style = 'visibility:hidden'
  link.download = nameFile

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export { JSON2CSV }
